(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cf-bundle"] && !Shopify.designMode) return;
  try {
    
class CfBundleSwap extends HTMLElement {
  connectedCallback() {
    this.buttons = [...this.querySelectorAll('.cf-bundle__buttons [data-slot]')];
    this.images = [...this.querySelectorAll('.cf-bundle__slot[data-slot]')];
    if (this.images.length < 2) return;
    this.buttons.forEach((btn) => {
      const activate = () => this.activate(btn.dataset.slot);
      // Touch-generated hover must not reveal an image before the link click:
      // Safari can consume that first tap when hover changes visibility.
      btn.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse') activate();
      });
      btn.addEventListener('focusin', () => {
        if (btn.matches(':focus-visible')) activate();
      });
    });
  }

  // swap sticks after the pointer leaves, like ta-bundle did
  activate(slot) {
    this.buttons.forEach((b) => b.classList.toggle('is-active', b.dataset.slot === slot));
    this.images.forEach((img) => {
      img.classList.toggle('is-active', img.dataset.slot === slot);
      // is-hidden outranks the slot-1 no-JS default so slot 1 can fade out too
      img.classList.toggle('is-hidden', img.dataset.slot !== slot);
    });
  }
}

if (!customElements.get('cf-bundle-swap')) customElements.define('cf-bundle-swap', CfBundleSwap);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cf-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cf-hero-slider')) {
  customElements.define('cf-hero-slider', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.cf-hero__track');
      this.slides = [...this.querySelectorAll('.cf-hero__slide')];
      this.dots = [...this.querySelectorAll('[data-slide-to]')];
      this.status = this.querySelector('[data-current-slide]');
      this.liveStatus = this.querySelector('[data-slide-status]');
      this.pauseButton = this.querySelector('[data-pause]');
      this.interval = Math.max(0, Number(this.dataset.autoplaySeconds) || 0) * 1000;
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.activeIndex = 0;
      this.targetIndex = null;
      this.paused = false;
      this.hovered = false;
      this.pointerDown = false;
      this.scrolling = false;
      this.editorSelected = false;
      this.inView = true;
      this.drag = null;
      this.suppressClick = false;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      if (!this.slides.length) return;

      this.classList.add('is-ready');
      // Dots and the autoplay clock wait for the later slides to exist.
      const controls = this.querySelector('.cf-hero__controls');
      const firstImage = this.slides[0].querySelector('img');
      const revealSlides = () => {
        this.classList.add('is-loaded');
        if (controls) controls.hidden = this.slides.length < 2;
        this.startAutoplay();
      };
      if (!firstImage || firstImage.complete) {
        revealSlides();
      } else {
        firstImage.addEventListener('load', revealSlides, { once: true, ...options });
        firstImage.addEventListener('error', revealSlides, { once: true, ...options });
      }
      this.updateActive(0);

      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.goTo(index), options));

      this.track.addEventListener('scroll', () => {
        this.scrolling = true;
        this.stopAutoplay();
        cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = requestAnimationFrame(() => this.syncActive());
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => {
          this.targetIndex = null;
          this.scrolling = false;
          this.syncActive();
          this.startAutoplay();
        }, 150);
      }, { ...options, passive: true });
      this.track.addEventListener('pointerdown', event => this.beginDrag(event), options);
      document.addEventListener('pointermove', event => this.moveDrag(event), options);
      document.addEventListener('pointerup', event => this.endDrag(event), options);
      document.addEventListener('pointercancel', event => this.endDrag(event, true), options);
      this.track.addEventListener('lostpointercapture', event => this.endDrag(event, true), options);
      this.track.addEventListener('dragstart', event => event.preventDefault(), options);
      this.track.addEventListener('click', event => {
        if (!this.suppressClick) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.suppressClick = false;
      }, { ...options, capture: true });
      this.track.addEventListener('wheel', () => {
        this.targetIndex = null;
        this.startAutoplay();
      }, { ...options, passive: true });

      this.addEventListener('pointerenter', event => {
        if (event.pointerType === 'touch') return;
        this.hovered = true;
        this.startAutoplay();
      }, options);
      this.addEventListener('pointerleave', event => {
        if (event.pointerType === 'touch') return;
        this.hovered = false;
        this.startAutoplay();
      }, options);
      this.addEventListener('focusin', () => this.startAutoplay(), options);
      this.addEventListener('focusout', () => queueMicrotask(() => {
        if (this.isConnected) this.startAutoplay();
      }), options);
      document.addEventListener('visibilitychange', () => this.startAutoplay(), options);
      window.addEventListener('blur', () => this.endDrag({ pointerId: this.drag?.pointerId }, true), options);
      this.reducedMotion.addEventListener('change', () => this.startAutoplay(), options);
      this.pauseButton?.addEventListener('click', () => {
        this.paused = !this.paused;
        this.pauseButton.textContent = this.paused ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel;
        this.startAutoplay();
      }, options);

      this.addEventListener('keydown', (event) => {
        if (event.target.closest('input, textarea, select, [contenteditable="true"]')) return;
        if (event.altKey || event.ctrlKey || event.metaKey) return;
        const current = this.targetIndex ?? this.activeIndex;
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        let next;
        if (event.key === 'ArrowRight') next = current + (rtl ? -1 : 1);
        if (event.key === 'ArrowLeft') next = current + (rtl ? 1 : -1);
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.slides.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        this.goTo(next);
      }, options);

      this.addEventListener('shopify:block:select', (event) => {
        const index = this.slides.findIndex(slide => slide.dataset.slideId === event.detail.blockId || slide.contains(event.target));
        if (index >= 0) {
          this.editorSelected = true;
          this.goTo(index, false);
        }
      }, options);
      this.addEventListener('shopify:block:deselect', () => {
        this.editorSelected = false;
        this.startAutoplay();
      }, options);

      this.resizeObserver = new ResizeObserver(() => this.goTo(this.targetIndex ?? this.activeIndex, false));
      this.resizeObserver.observe(this.track);
      this.intersectionObserver = new IntersectionObserver(([entry]) => {
        this.inView = entry.isIntersecting;
        this.startAutoplay();
      });
      this.intersectionObserver.observe(this);
      this.startAutoplay();
    }

    disconnectedCallback() {
      this.events?.abort();
      this.resizeObserver?.disconnect();
      this.intersectionObserver?.disconnect();
      this.stopAutoplay();
      cancelAnimationFrame(this.scrollFrame);
      clearTimeout(this.scrollTimer);
      clearTimeout(this.clickTimer);
      this.track?.classList.remove('is-dragging');
    }

    goTo(index, smooth = true) {
      this.stopAutoplay();
      index = (index + this.slides.length) % this.slides.length;
      const slide = this.slides[index];
      const left = this.track.scrollLeft + slide.getBoundingClientRect().left - this.track.getBoundingClientRect().left;
      const animate = smooth && !this.reducedMotion.matches;
      this.targetIndex = animate ? index : null;
      this.scrolling = Math.abs(this.track.scrollLeft - left) > 1;
      this.track.scrollTo({ left, behavior: animate ? 'smooth' : 'instant' });
      this.updateActive(index);
      if (!this.scrolling) this.startAutoplay();
    }

    stopAutoplay() {
      clearTimeout(this.autoplayTimer);
    }

    startAutoplay() {
      this.stopAutoplay();
      const enabled = this.interval > 0 && this.slides.length > 1 && !this.reducedMotion.matches;
      const running = enabled && this.isConnected && this.classList.contains('is-loaded') && this.inView && !this.paused && !this.hovered &&
        !this.pointerDown && !this.scrolling && !this.editorSelected && !document.hidden && !this.contains(document.activeElement);
      if (this.pauseButton) this.pauseButton.hidden = !enabled;
      if (this.liveStatus) this.liveStatus.setAttribute('aria-live', running ? 'off' : 'polite');
      if (running) this.autoplayTimer = setTimeout(() => this.goTo(this.activeIndex + 1), this.interval);
    }

    beginDrag(event) {
      if (!event.isPrimary || event.button !== 0 || this.slides.length < 2) return;
      this.pointerDown = true;
      this.targetIndex = null;
      this.startAutoplay();
      if (event.pointerType !== 'mouse') return;
      this.drag = {
        pointerId: event.pointerId,
        x: event.clientX,
        y: event.clientY,
        lastX: event.clientX,
        scrollLeft: this.track.scrollLeft,
        index: this.activeIndex,
        moved: false
      };
    }

    moveDrag(event) {
      const drag = this.drag;
      if (!drag || event.pointerId !== drag.pointerId) return;
      const dx = event.clientX - drag.x;
      const dy = event.clientY - drag.y;
      if (!drag.moved) {
        if (Math.abs(dx) < 6 || Math.abs(dx) <= Math.abs(dy)) return;
        drag.moved = true;
        this.track.classList.add('is-dragging');
        this.track.setPointerCapture(event.pointerId);
      }
      event.preventDefault();
      drag.lastX = event.clientX;
      this.track.scrollLeft = drag.scrollLeft - dx;
    }

    endDrag(event, cancelled = false) {
      if (!this.pointerDown) return;
      const drag = this.drag;
      if (drag && event.pointerId !== drag.pointerId) return;
      this.pointerDown = false;
      this.drag = null;
      this.track.classList.remove('is-dragging');
      if (drag?.moved) {
        if (this.track.hasPointerCapture(drag.pointerId)) this.track.releasePointerCapture(drag.pointerId);
        this.suppressClick = true;
        clearTimeout(this.clickTimer);
        this.clickTimer = setTimeout(() => { this.suppressClick = false; }, 0);
        const dx = drag.lastX - drag.x;
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const direction = (dx < 0 ? 1 : -1) * (rtl ? -1 : 1);
        this.goTo(drag.index + (!cancelled && Math.abs(dx) >= 40 ? direction : 0));
      } else {
        this.startAutoplay();
      }
    }

    syncActive() {
      const left = this.track.getBoundingClientRect().left;
      let closest = 0;
      let distance = Infinity;
      this.slides.forEach((slide, index) => {
        const offset = Math.abs(slide.getBoundingClientRect().left - left);
        if (offset < distance) {
          closest = index;
          distance = offset;
        }
      });
      if (this.targetIndex !== null) {
        if (closest !== this.targetIndex || distance >= 2) return;
        this.targetIndex = null;
      }
      this.updateActive(closest);
    }

    updateActive(index) {
      this.activeIndex = index;
      this.slides.forEach((slide, position) => {
        const active = position === index;
        if (!active && slide.contains(document.activeElement)) this.track.focus({ preventScroll: true });
        slide.inert = !active;
        slide.setAttribute('aria-hidden', String(!active));
      });
      this.dots.forEach((dot, position) => {
        if (position === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      if (this.status && this.status.textContent !== String(index + 1)) this.status.textContent = String(index + 1);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cf-products-tabs"] && !Shopify.designMode) return;
  try {
    
class CfTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = [...this.querySelectorAll('[role="tab"]')];
    this.tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => this.select(i));
      tab.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') this.select((i + 1) % this.tabs.length, true);
        if (e.key === 'ArrowLeft') this.select((i - 1 + this.tabs.length) % this.tabs.length, true);
      });
    });
  }

  select(index, focus) {
    this.tabs.forEach((tab, i) => {
      const active = i === index;
      tab.setAttribute('aria-selected', active);
      tab.tabIndex = active ? 0 : -1;
      const panel = this.querySelector('#' + tab.getAttribute('aria-controls'));
      if (panel) panel.hidden = !active;
      if (active && focus) tab.focus();
    });
    this.center(this.tabs[index]);
  }

  // When the list scrolls, bring the chosen tab to the middle so the
  // neighbour on either side peeks in. Clamped by the browser at the ends,
  // so the first/last tab simply sit at their edge.
  center(tab) {
    const list = tab.parentElement;
    if (list.scrollWidth <= list.clientWidth + 1) return;
    tab.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
  }
}

class CfSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.cf-slider__track');
    this.prev = this.querySelector('[name="previous"]');
    this.next = this.querySelector('[name="next"]');
    this.prev.addEventListener('click', () => this.page(-1));
    this.next.addEventListener('click', () => this.page(1));
    this.track.addEventListener('scroll', () => this.update(), { passive: true });
    new ResizeObserver(() => this.update()).observe(this.track);
    this.update();
  }

  page(dir) {
    const item = this.track.firstElementChild;
    const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
    const step = item ? item.getBoundingClientRect().width + gap : this.track.clientWidth;
    this.track.scrollBy({ left: dir * step, behavior: 'smooth' });
  }

  update() {
    const { scrollLeft, scrollWidth, clientWidth } = this.track;
    this.classList.toggle('cf-slider--static', scrollWidth <= clientWidth + 1);
    this.prev.toggleAttribute('disabled', scrollLeft <= 1);
    this.next.toggleAttribute('disabled', scrollLeft >= scrollWidth - clientWidth - 1);
  }
}

if (!customElements.get('cf-tabs')) customElements.define('cf-tabs', CfTabs);
if (!customElements.get('cf-slider')) customElements.define('cf-slider', CfSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ta-bundle"] && !Shopify.designMode) return;
  try {
    
class TaBundle extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('.ta-bundle__buttons [data-slot]').forEach((btn) => {
      const activate = () => this.activate(btn.dataset.slot);
      btn.addEventListener('mouseenter', activate);
      btn.addEventListener('focusin', activate);
    });
  }

  activate(slot) {
    if (!this.querySelector(`.ta-bundle__img[data-slot="${slot}"]`)) return;
    this.querySelectorAll('[data-slot]').forEach((el) => {
      el.classList.toggle('is-active', el.dataset.slot === slot);
    });
  }
}

if (!customElements.get('ta-bundle')) customElements.define('ta-bundle', TaBundle);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ta-featured-collection"] && !Shopify.designMode) return;
  try {
    
class TaSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.ta-slider__track');
    this.prev = this.querySelector('[name="previous"]');
    this.next = this.querySelector('[name="next"]');
    this.prev.addEventListener('click', () => this.page(-1));
    this.next.addEventListener('click', () => this.page(1));
    this.track.addEventListener('scroll', () => this.update(), { passive: true });
    new ResizeObserver(() => this.update()).observe(this.track);
    this.update();
  }

  page(dir) {
    this.track.scrollBy({ left: dir * this.track.clientWidth, behavior: 'smooth' });
  }

  update() {
    const { scrollLeft, scrollWidth, clientWidth } = this.track;
    this.classList.toggle('ta-slider--static', scrollWidth <= clientWidth + 1);
    this.prev.toggleAttribute('disabled', scrollLeft <= 1);
    this.next.toggleAttribute('disabled', scrollLeft >= scrollWidth - clientWidth - 1);
  }
}

if (!customElements.get('ta-slider')) customElements.define('ta-slider', TaSlider);

  } catch(e) { console.error(e); }
})();
})();
